var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/lodash/_Map.js
// module id = LOeM
// module chunks = 0